import { useEffect, useState } from "react";
import { CheckCircle, X, UserCircle } from "@phosphor-icons/react";
import api from "../../lib/api";

export default function SimulateModal({ automationId, onClose }) {
  const [customers, setCustomers] = useState([]);
  const [q, setQ] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/customers${q ? `?q=${encodeURIComponent(q)}` : ""}`)
        .then((r) => setCustomers(r.data.slice(0, 8)))
        .catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  const run = async () => {
    setRunning(true);
    try {
      const r = await api.post(`/automations/${automationId}/simulate`, { customer_id: customerId || null });
      setResult(r.data);
    } catch (e) {
      setResult({ error: e?.response?.data?.detail || "Errore simulazione" });
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-lg rounded-t-xl sm:rounded-lg max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="simulate-modal">
        <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-200">
          <h3 className="font-display font-bold text-lg">Simula workflow</h3>
          <button onClick={onClose} className="p-2 text-zinc-500" data-testid="simulate-close"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-4 overflow-y-auto">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-zinc-500 mb-1">Cliente di test</label>
            <input value={q} onChange={(e) => { setQ(e.target.value); setCustomerId(""); }} placeholder="Cerca cliente reale... (vuoto = fittizio)"
              className="w-full h-11 px-3 rounded-md border border-zinc-300 text-sm" data-testid="simulate-search" />
            {q && !customerId && customers.length > 0 && (
              <div className="mt-1 border border-zinc-200 rounded-md divide-y divide-zinc-100 bg-white">
                {customers.map((c) => (
                  <button key={c.id} onClick={() => { setCustomerId(c.id); setQ(`${c.first_name} ${c.last_name}`); }}
                    data-testid={`simulate-customer-${c.id}`}
                    className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-zinc-50 text-left">
                    <UserCircle size={16} className="text-zinc-400" /> {c.first_name} {c.last_name} <span className="text-xs text-zinc-400">{c.phone}</span>
                  </button>
                ))}
              </div>
            )}
            {customerId && <p className="text-xs text-emerald-700 mt-1">Cliente selezionato — la simulazione userà i suoi dati reali</p>}
            {!customerId && <p className="text-xs text-zinc-400 mt-1">Nessun cliente selezionato: verrà usato "Mario Rossi (test)"</p>}
          </div>
          <button onClick={run} disabled={running} data-testid="simulate-run"
            className="w-full h-12 rounded-md bg-zinc-900 text-white font-semibold text-sm hover:bg-zinc-800 active:scale-[0.98] transition disabled:opacity-50">
            {running ? "Simulazione..." : "Avvia simulazione"}
          </button>
          {result && (
            <div className="space-y-2" data-testid="simulate-result">
              {result.error && <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2">{result.error}</div>}
              {result.steps && (
                <>
                  <div className="text-xs text-zinc-500">Simulazione per <strong>{result.customer}</strong> — nessun messaggio inviato davvero.</div>
                  {result.steps.map((s, i) => (
                    <div key={i} className="flex gap-3 items-start">
                      <div className="flex flex-col items-center">
                        <span className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white ${
                          s.type === "trigger" ? "bg-amber-500" : s.type === "condition" ? "bg-blue-500" : s.type === "wait" ? "bg-zinc-500" : "bg-emerald-500"}`}>
                          {i + 1}
                        </span>
                        {i < result.steps.length - 1 && <span className="w-px h-6 bg-zinc-200" />}
                      </div>
                      <div className="flex-1 pb-1">
                        <div className="text-sm font-semibold text-zinc-900 flex items-center gap-2">
                          {s.node}
                          {s.type === "condition" && (
                            s.result
                              ? <CheckCircle size={14} weight="fill" className="text-emerald-500" />
                              : <X size={14} weight="bold" className="text-rose-500" />
                          )}
                        </div>
                        <div className="text-xs text-zinc-600 whitespace-pre-wrap">{s.detail}</div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
